module.exports = __webpack_public_path__ + "static/Postscript-99f83c1114bdd6de890f1574935258cf.svg";